// Display labels for plan tiers — shared by the demo plan switchers
// (dashboard chip, viewer badge) so the labels never drift.
import type { PlanType } from "@/types/subscription.types";

export const PLAN_LABELS: Record<PlanType, string> = {
  free: "Free",
  lite: "Lite",
  plus: "Plus",
  pro: "Pro",
  agency: "Agency",
};


